/**
 * @author SwathiDivya Bhavaraju
 * @email swathidivya.bhavaraju@ul.com
 * @create date 2025-12-01 13:15:47
 * @modify date 2025-12-01 13:15:47
 * @desc [description]
 */
import axios from 'axios';

/**
 * regenerate post api
 * to regenerate the otp */
export async function regenrateMfaOtp(data) {
  let result = '';
  await axios.post(`${process.env.VUE_APP_JAVA_API_URL}/userApiMfa/regenerate`, data)
    .then((response) => {
      if (response.status === 200) {
        result = response.data;
      }
    })
    .catch((err) => {
      console.log('regenerate mfa otp java api error', err); // eslint-disable-line no-console
    });
  return result;
}

/**
 * validate post api
 * to post the otp and validate it */
export async function validateMfaOtp(data) {
  let result = '';
  await axios.post(`${process.env.VUE_APP_JAVA_API_URL}/userApiMfa/validate`, data)
    .then((response) => {
      if (response.status === 200) {
        result = response.data;
      }
    })
    .catch((err) => {
      console.log('validate mfa otp java api error', err); // eslint-disable-line no-console
      result =err.response.data;
    });
  return result;
}
